<!-- <div class="fixed inset-x-0 bottom-0 bg-gray-100 z-40 lg:pr-40 lg:pl-40"> -->
<!-- <div
  class="fixed top-[64px] inset-x-0 bg-gray-100 z-40 lg:pr-66 lg:pl-69 rtl:lg:pr-66 rtl:lg:pl-66 lg:top-auto lg:bottom-0 animate-slide-down lg:animate-slide-up"
> -->
<div
  class="service-progress fixed top-[64px] inset-x-0 bg-gray-100 z-40 lg:pr-66 lg:pl-12 rtl:lg:pr-12 rtl:lg:pl-12 lg:top-auto lg:bottom-0 animate-slide-down lg:animate-slide-up"
>
  <div class="flex items-center justify-between m-5">
    <!-- Progress -->
    <div>
      <h3 class="text-xl font-semibold text-dc-navy">
        {{ serviceName }}
      </h3>
      @if (description) {
      <span class="text-dc-navy text-lg">{{ description }}</span>
      } @if (showProgress) {
      <div class="flex items-center gap-2 mt-1 text-base text-gray-700">
        <span class="text-dc-navy">
          {{ "COMPLETE" | translate : { percent: completePercentage } }}</span
        >
        <div class="w-28 h-2 bg-gray-300 rounded overflow-hidden">
          <div
            class="bg-dc-blue h-full"
            [ngStyle]="{ width: completePercentage + '%' }"
          ></div>
        </div>
      </div>
      }
    </div>

    <!--Chat Button -->
    @if(showChatWithUs){
    <button
      class="flex items-center gap-2 bg-white px-4 py-2 text-base hover:bg-gray-100"
      (click)="onChatWithUs($event)"
    >
      <img src="/icons/svg/chat.svg" />
      <span class="text-dc-navy font-medium hidden lg:inline">{{
        "CHAT_WITH_US" | translate
      }}</span>
    </button>
    }
  </div>
</div>
